/**
 * defa.collections.dayAndNightSettings
 * A Collection of DayAndNightSetting
 * @version 1.2.0
 */
import DayAndNightSetting from 'scripts/defa/control/day-and-night/model-day-and-night-setting';

const DayAndNightSettings = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : DayAndNightSetting,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default DayAndNightSettings
